import { EMPTY_VALUE_LABEL } from '@/components/ag-cells/labels'

export const EmptyCellValue = () => (
  <span className='text-main-foreground-tertiary text-body-default'>{EMPTY_VALUE_LABEL}</span>
)
